// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__en4kr","loader":"Loader_loader__ScBwR"};